import React, {FC, ReactElement, useCallback, useMemo} from 'react';
import Typography from '@material-ui/core/Typography';
import Pagination from '@material-ui/lab/Pagination';
import {Box, CircularProgress, makeStyles} from '@material-ui/core';
import SearchResultsList from './SearchResultsList';
import {useSearchContext} from '@context';
import {strings} from '@constants';

const useStyles = makeStyles(theme => ({
    statusbar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        color: theme.palette.text.secondary
    },
    progress: {
        marginLeft: theme.spacing(1),
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center'
    }
}));

const SearchResults: FC = (): ReactElement => {
    const classes = useStyles();
    const {filter: {searchString, from, size}, updateFilter, loading, result: {total}} = useSearchContext();

    const pageRange = useMemo(() => `${from + 1} - ${Math.min(from + size, total)}`,
        [from, size, total]);

    const page = useMemo(() => (from / size) + 1, [from, size]);

    const totalPages = useMemo(() => Math.ceil(total / size), [size, total]);

    const handlePageChange = useCallback((_, page) => {
        updateFilter({from: (page - 1) * size});
    }, [updateFilter, size]);

    return (
        <>
            <Box className={classes.statusbar}>
                {loading
                    ? (
                        <>
                            <Typography>{strings.loading}</Typography>
                            <CircularProgress className={classes.progress} size="0.75rem" color="inherit"/>
                        </>
                    )
                    : (
                        <Typography>{strings.showingResults(pageRange, total, searchString)}</Typography>
                    )
                }
            </Box>
            <SearchResultsList/>
            <Pagination
                className={classes.pagination}
                color="standard"
                page={page}
                count={totalPages}
                onChange={handlePageChange}/>
        </>
    );
};

export default SearchResults;
